import React from "react";
import Content from "../Content";
import useDropdownSubmenuItems from "./hooks/useDropdownSubmenuItems";
import { BaseSubContent, BaseSubmenu, BaseSubTrigger } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Submenu(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    shortcut = _ref.shortcut,
    subMenu = _ref.subMenu,
    indentContent = _ref.indentContent;
  var dropdownSubMenuComponents = useDropdownSubmenuItems(subMenu);
  return /*#__PURE__*/_jsxs(BaseSubmenu, {
    children: [/*#__PURE__*/_jsx(BaseSubTrigger, {
      indentContent: indentContent,
      children: /*#__PURE__*/_jsx(Content, {
        icon: icon,
        label: label,
        showSubmenuIndicator: true,
        shortcut: shortcut
      })
    }), /*#__PURE__*/_jsx(BaseSubContent, {
      children: dropdownSubMenuComponents
    })]
  });
}
export default Submenu;